import { render, staticRenderFns } from "./DriverAcceptPage.vue?vue&type=template&id=09864674&"
import script from "./DriverAcceptPage.vue?vue&type=script&lang=js&"
export * from "./DriverAcceptPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports